import { IncidentLayout } from "./components/incidentLayout";
import { INCIDENT_2026_10_16 } from "./content/incident20261016";

/** /incidentes/2026-10-16 — relatório público do incidente, fechado e em noindex. */
export const Incidente20261016 = () => (
  <IncidentLayout document={INCIDENT_2026_10_16} />
);
